"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PACKAGE_BILLING_SELECTION_MODES = exports.PACKAGE_BILLING_PRICE_KEYS = void 0;
exports.isBillingTierSlug = isBillingTierSlug;
exports.highestBillingTierSlug = highestBillingTierSlug;
exports.expandPackageIncludes = expandPackageIncludes;
exports.chargeableSlugsFromSelection = chargeableSlugsFromSelection;
exports.formatPackageIncludesLabel = formatPackageIncludesLabel;
exports.filterTopLevelActiveSlugs = filterTopLevelActiveSlugs;
exports.legacySelectionToSlugs = legacySelectionToSlugs;
exports.normalizeBillingSelection = normalizeBillingSelection;
exports.resolveBillingTierFromSlugs = resolveBillingTierFromSlugs;
exports.resolvePackageFlagsFromSlugs = resolvePackageFlagsFromSlugs;
const package_catalog_1 = require("./package-catalog");
exports.PACKAGE_BILLING_PRICE_KEYS = [
    'basic',
    'pro',
    'business',
];
exports.PACKAGE_BILLING_SELECTION_MODES = [
    'additive',
    'exclusive',
];
const TIER_SLUGS = ['pro', 'business'];
function isBillingTierSlug(slug) {
    const normalized = (0, package_catalog_1.normalizePackageSlug)(slug);
    return TIER_SLUGS.includes(normalized);
}
function highestBillingTierSlug(slugs) {
    const set = new Set([...slugs].map(package_catalog_1.normalizePackageSlug));
    if (set.has('business'))
        return 'business';
    if (set.has('pro'))
        return 'pro';
    return null;
}
/** Επέκταση selected + transitive includesSlugs (για flags, όχι για τιμολόγηση). */
function expandPackageIncludes(catalog, selectedSlugs) {
    const bySlug = new Map(catalog.map((p) => [p.slug, p]));
    const out = new Set();
    const visit = (slug) => {
        var _a;
        const normalized = (0, package_catalog_1.normalizePackageSlug)(slug);
        if (out.has(normalized))
            return;
        out.add(normalized);
        const pkg = bySlug.get(normalized);
        if (!pkg)
            return;
        for (const inc of (_a = pkg.includesSlugs) !== null && _a !== void 0 ? _a : []) {
            visit(inc);
        }
    };
    for (const slug of selectedSlugs) {
        visit(slug);
    }
    return out;
}
/** Slugs που χρεώνονται (additive: όλα τα επιλεγμένα στο βήμα, exclusive: ένα). */
function chargeableSlugsFromSelection(catalog, selectedSlugs) {
    const selected = new Set(selectedSlugs.map(package_catalog_1.normalizePackageSlug));
    const steps = (0, package_catalog_1.sortedPackageBillingSteps)(catalog);
    const chargeable = [];
    for (const step of steps) {
        const inStep = catalog.filter((p) => p.billingStep === step);
        if (inStep.length === 0)
            continue;
        const mode = inStep[0].billingSelectionMode;
        const picked = inStep.filter((p) => selected.has(p.slug));
        if (picked.length === 0)
            continue;
        if (mode === 'additive') {
            for (const pkg of picked) {
                if (pkg.billingPriceKey)
                    chargeable.push(pkg.slug);
            }
        }
        else {
            const priced = picked.filter((p) => p.billingPriceKey);
            if (priced.length > 0) {
                chargeable.push(priced[priced.length - 1].slug);
            }
        }
    }
    return chargeable;
}
function formatPackageIncludesLabel(catalog, pkg) {
    var _a;
    const slugs = (_a = pkg.includesSlugs) !== null && _a !== void 0 ? _a : [];
    if (slugs.length === 0)
        return null;
    const names = slugs.map((s) => { var _a, _b; return (_b = (_a = catalog.find((p) => p.slug === (0, package_catalog_1.normalizePackageSlug)(s))) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : s; });
    return `Περιλαμβάνει ${names.join(', ')}`;
}
/**
 * Από ενεργά slugs συνδρομών, κράτα μόνο τα «κορυφαία» — όχι αυτά που
 * καλύπτονται από includesSlugs άλλου ενεργού πακέτου (π.χ. μόνο Business, όχι Basic+Pro).
 */
function filterTopLevelActiveSlugs(catalog, activeSlugs) {
    const unique = [...new Set(activeSlugs.map((s) => (0, package_catalog_1.normalizePackageSlug)(s)))];
    return unique.filter((slug) => {
        for (const other of unique) {
            if (other === slug)
                continue;
            if (expandPackageIncludes(catalog, [other]).has(slug)) {
                return false;
            }
        }
        return true;
    });
}
function legacySelectionToSlugs(includePro, tier) {
    const slugs = [];
    if (includePro)
        slugs.push(package_catalog_1.PRO_PACKAGE_SLUG);
    if (tier)
        slugs.push(tier);
    return slugs;
}
function normalizeBillingSelection(catalog, input) {
    var _a;
    if (input.selectedSlugs && input.selectedSlugs.length > 0) {
        return [...new Set(input.selectedSlugs.map((s) => (0, package_catalog_1.normalizePackageSlug)(s)))];
    }
    const raw = (_a = input.tier) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    const tier = raw === 'pro' || raw === 'business' || raw === 'bronze' || raw === 'silver'
        ? 'pro'
        : raw === 'gold'
            ? 'business'
            : null;
    return legacySelectionToSlugs(Boolean(input.includePro), tier);
}
/** Υψηλότερο billing tier από επιλεγμένα slugs (χωρίς legacy User flags). */
function resolveBillingTierFromSlugs(slugs) {
    return highestBillingTierSlug(slugs);
}
/** @deprecated Χρησιμοποίησε resolveBillingTierFromSlugs */
function resolvePackageFlagsFromSlugs(slugs) {
    return { billingTier: resolveBillingTierFromSlugs(slugs) };
}
